import { CompanyOnboardingStrings } from "@/screen/Companies/companyOnboarding.strings";
import type { CompanyDetailsSection } from "@/screen/Companies/CompanyDetails/companyDetailsSections";

// Secciones del paso 4, en el orden de la pantalla (índice lateral y tarjetas numeradas)
export const CompanyKycSections: CompanyDetailsSection[] =
[
    { id: "company-kyc-pep", number: 1, title: CompanyOnboardingStrings.pepNavTitle },
    { id: "company-kyc-risk-countries", number: 2, title: CompanyOnboardingStrings.riskCountriesTitle },
    { id: "company-kyc-corporate", number: 3, title: CompanyOnboardingStrings.corporateNavTitle },
    { id: "company-kyc-funds", number: 4, title: CompanyOnboardingStrings.fundsNavTitle },
    { id: "company-kyc-fatca", number: 5, title: CompanyOnboardingStrings.fatcaTitle },
];
